import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ShareStudyModal = ({ study, onClose, onShareSuccess }) => {
  const [commercials, setCommercials] = useState([]);
  const [selectedCommercials, setSelectedCommercials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sharing, setSharing] = useState(false);

  useEffect(() => {
    fetchCommercials();
  }, []);

  const fetchCommercials = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.get(`${API}/users/commercials`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCommercials(response.data);
    } catch (error) {
      console.error('Error fetching commercials:', error);
      alert('Erreur lors du chargement de la liste des commerciaux');
    } finally {
      setLoading(false);
    }
  };

  const toggleCommercial = (userId) => {
    setSelectedCommercials(prev => 
      prev.includes(userId)
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const handleShare = async () => {
    if (selectedCommercials.length === 0) {
      alert('Veuillez sélectionner au moins un commercial');
      return;
    }

    try {
      setSharing(true);
      const token = localStorage.getItem('access_token');
      await axios.post(
        `${API}/analysis/${study.analysis_id}/share`,
        { commercial_user_ids: selectedCommercials },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      onShareSuccess();
      onClose();
    } catch (error) {
      console.error('Error sharing study:', error);
      alert('Erreur lors du partage de l\'étude');
    } finally {
      setSharing(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '80vh',
        overflow: 'auto',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
      }}>
        <h2 style={{
          fontFamily: 'var(--font-titre)',
          fontSize: '1.5rem',
          color: 'var(--pde-anthracite)',
          marginBottom: '1rem'
        }}>
          Partager l'étude
        </h2>

        <p style={{
          fontFamily: 'var(--font-corps)',
          color: 'var(--pde-gris-acier)',
          marginBottom: '1.5rem'
        }}>
          <strong>{study.client_name}</strong>
        </p>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <p style={{ color: 'var(--pde-gris-acier)' }}>Chargement...</p>
          </div>
        ) : commercials.length === 0 ? (
          <div style={{
            padding: '2rem',
            textAlign: 'center',
            background: '#f3f4f6',
            borderRadius: '8px'
          }}>
            <p style={{ color: 'var(--pde-gris-acier)', margin: 0 }}>
              Aucun commercial disponible
            </p>
          </div>
        ) : (
          <>
            <div style={{
              marginBottom: '1.5rem',
              maxHeight: '300px',
              overflow: 'auto',
              border: '1px solid var(--pde-border)',
              borderRadius: '8px',
              padding: '1rem'
            }}>
              <p style={{
                fontFamily: 'var(--font-corps)',
                fontSize: '0.875rem',
                fontWeight: '600',
                color: 'var(--pde-anthracite)',
                marginBottom: '1rem'
              }}>
                Sélectionner les commerciaux :
              </p>
              
              {commercials.map((commercial) => (
                <label
                  key={commercial.user_id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0.75rem',
                    cursor: 'pointer',
                    borderRadius: '6px',
                    transition: 'background 0.2s',
                    background: selectedCommercials.includes(commercial.user_id) ? '#e0f2fe' : 'transparent'
                  }}
                  onMouseEnter={(e) => {
                    if (!selectedCommercials.includes(commercial.user_id)) {
                      e.currentTarget.style.background = '#f3f4f6';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!selectedCommercials.includes(commercial.user_id)) {
                      e.currentTarget.style.background = 'transparent';
                    }
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedCommercials.includes(commercial.user_id)}
                    onChange={() => toggleCommercial(commercial.user_id)}
                    style={{
                      width: '1.25rem',
                      height: '1.25rem',
                      marginRight: '0.75rem',
                      cursor: 'pointer'
                    }}
                  />
                  <div>
                    <div style={{
                      fontFamily: 'var(--font-corps)',
                      fontWeight: '600',
                      color: 'var(--pde-anthracite)'
                    }}>
                      {commercial.username}
                    </div>
                    <div style={{
                      fontFamily: 'var(--font-corps)',
                      fontSize: '0.75rem',
                      color: 'var(--pde-gris-acier)'
                    }}>
                      {commercial.email}
                    </div>
                  </div>
                </label>
              ))}
            </div>

            <div style={{
              padding: '0.75rem',
              background: '#f0f9ff',
              border: '1px solid #bae6fd',
              borderRadius: '8px',
              marginBottom: '1.5rem'
            }}>
              <p style={{
                fontFamily: 'var(--font-corps)',
                fontSize: '0.875rem',
                color: '#0c4a6e',
                margin: 0
              }}>
                {selectedCommercials.length} commercial{selectedCommercials.length > 1 ? 'aux' : ''} sélectionné{selectedCommercials.length > 1 ? 's' : ''}
              </p>
            </div>
          </>
        )}

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            disabled={sharing}
            style={{
              padding: '0.75rem 1.5rem',
              border: '1px solid var(--pde-border)',
              borderRadius: '8px',
              background: 'white',
              color: 'var(--pde-anthracite)',
              fontFamily: 'var(--font-corps)',
              fontWeight: '600',
              cursor: sharing ? 'not-allowed' : 'pointer',
              opacity: sharing ? 0.5 : 1
            }}
          >
            Annuler
          </button>
          
          <button
            onClick={handleShare}
            disabled={sharing || selectedCommercials.length === 0}
            style={{
              padding: '0.75rem 1.5rem',
              border: 'none',
              borderRadius: '8px',
              background: sharing || selectedCommercials.length === 0 ? '#cbd5e1' : 'var(--pde-azur)',
              color: 'white',
              fontFamily: 'var(--font-corps)',
              fontWeight: '600',
              cursor: sharing || selectedCommercials.length === 0 ? 'not-allowed' : 'pointer'
            }}
          >
            {sharing ? 'Partage en cours...' : 'Partager'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareStudyModal;
